import type { AvailableOrgResponse } from "./api";

// Чистая функция кардинальности (ADR-0038 §3): сколько организаций у
// user'а определяет, что показывает `/select-org` — без DOM, юнит-тест
// как у `layout/breadcrumbs.ts`.

export type OrgSelectionDecision =
  | { readonly kind: "auto"; readonly orgId: string }
  | { readonly kind: "picker" }
  | { readonly kind: "empty" };

export function decideOrgSelection(
  orgs: readonly AvailableOrgResponse[],
): OrgSelectionDecision {
  // Деструктуризация вместо `orgs.length === 0` / `=== 1`: под
  // `noUncheckedIndexedAccess` индексный доступ даёт `T | undefined`, и
  // проверка `firstOrg !== undefined` рядом с `length === 1` была бы
  // недостижимой веткой (гейт покрытия — 100% branches).
  const [firstOrg, ...restOrgs] = orgs;
  if (firstOrg === undefined) {
    return { kind: "empty" };
  }
  if (restOrgs.length === 0) {
    return { kind: "auto", orgId: firstOrg.org_id };
  }
  return { kind: "picker" };
}
